// Navigation utility functions for smooth scrolling and consistent navigation behavior
import React from 'react';

export const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth'
  });
};

export const scrollToTopInstant = () => {
  window.scrollTo({
    top: 0,
    behavior: 'auto'
  });
};

export const scrollToSection = (sectionId: string) => {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

// Enhanced navigation handler for page navigation with immediate scroll to top
export const handlePageNavigation = () => {
  // Immediately scroll to top without animation for instant navigation
  scrollToTopInstant();
};

// Enhanced navigation handler for section navigation within the same page
export const handleSectionNavigation = (sectionId: string, event?: React.MouseEvent) => {
  if (event) {
    event.preventDefault();
  }
  
  // Add a small delay to ensure DOM is ready
  setTimeout(() => {
    scrollToSection(sectionId);
  }, 100);
};

// Service ID mappings for section anchors
export const SERVICE_SECTIONS = {
  'built-to-suit-gpu-clusters': 'built-to-suit-gpu-clusters',
  'nvidia-gpu-node-leasing': 'nvidia-gpu-node-leasing', 
  'on-demand-cloud-gpu-compute': 'on-demand-cloud-gpu-compute',
  'ai-software-solutions': 'ai-software-solutions',
  'gpu-clusters': 'built-to-suit-gpu-clusters',
  'gpu-leasing': 'nvidia-gpu-node-leasing',
  'on-demand': 'on-demand-cloud-gpu-compute',
  'ai-solutions': 'ai-software-solutions'
} as const;

export const getServiceSectionId = (serviceSlug: string): string => {
  return SERVICE_SECTIONS[serviceSlug as keyof typeof SERVICE_SECTIONS] || serviceSlug;
};
